<template>
  <div class="detailed-table">
    <vxe-table
      ref="xTable"
      resizable
      show-overflow
      :data="value"
      :edit-config="{
        trigger: 'click',
        mode: 'cell',
        activeMethod: activeCellMethod,
      }"
      @radio-change="radioChangeEvent"
    >
      <vxe-table-column
        v-for="(item, k) in columns"
        :key="k"
        v-bind="itemRender(item)"
      >
        <template #default="{ row }">
          <div>{{ resetText(row, item.field) }}</div>
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
import request from '../../../../../../../utils/request';

export default {
  props: {
    value: Array,
    disabled: Boolean,
    getValue: Function,
    setValue: Function,
    hiddenFields: Function,
    functionCode: String,
    parentCode: String,
  },
  data() {
    return {
      columns: [],
      fieldList: null,
      numberList: ['wayMoney', 'distanceAstrict'], // 数字格式
      selectRow: null,
      scanTypeList: [], // 扫码类型
      awardWayList: [], // 每扫基本单位给终端
      wayTypeList: [], // 奖励类型
    };
  },
  watch: {
    functionCode(val) {
      if (val) {
        this.getColumn(val);
      } else {
        this.columns = [];
      }
    },
    value(val) {
      this.getTypeList();
    },
  },
  components: {},
  created() {
    if (this.functionCode) {
      this.getColumn(this.functionCode);
    }
  },
  methods: {
    // 选择列表数据
    radioChangeEvent({ row }) {
      this.selectRow = row;
    },

    // 获取表格配置
    getColumn(functionCode) {
      const parentCode = this.parentCode
        ? this.parentCode
        : this.$store.state.menus.selectMenu;

      request
        .post('/mdm/mdmtableconfig/query', { functionCode, parentCode })
        .then((res) => {
          if (res.success) {
            const _fields = {};
            res.result.column.forEach((v) => {
              _fields[v.field] = '';
            });

            this.fieldList = _fields;
            this.columns = res.result.column.filter((v) => v.visible);
            if (this.value.length === 0) {
              const params = {};
              const list = JSON.parse(JSON.stringify(this.value || []));
              list.push({ ...this.fieldList, ...params });
              this.$emit('input', list);
              this.selectRow = null;
            }
          }
        });
    },
    // 单元格渲染
    itemRender(item) {
      const { title, field, type } = item;
      let column = {
        title,
        field,
        minWidth: 150,
      };
      let editRender = null;
      if (field === 'checkTyperadio' || field === 'checkTypecheckbox') {
        column = {
          type: field === 'checkTyperadio' ? 'radio' : 'checkbox',
          width: '36',
          fixed: 'left',
          visible: !this.disabled,
        };
      } else if (!this.disabled && type === 'input') {
        if (this.numberList.includes(field)) {
          editRender = {
            name: 'ElInputNumber',
            props: {
              placeholder: `请输入${title}`,
              clearable: true,
              controls: false,
              min: 0,
              precision: field === 'distanceAstrict' ? 0 : 2,
              value: undefined,
            },
            events: {
              change: ({ row, rowIndex }) => {
                this.changeRow(field, row, rowIndex);
              },
            },
          };
        } else {
          editRender = {
            name: 'ElInput',
            props: {
              placeholder: `请输入${title}`,
              clearable: true,
            },
          };
        }
      } else if (!this.disabled && type === 'select') {
        editRender = { name: 'ElSelect' };

        if (
          field === 'scanType'
          || field === 'awardWay'
          || field === 'wayType'
        ) {
          editRender = {
            ...editRender,
            props: {
              placeholder: `请选择${title}`,
              clearable: true,
              filterable: true,
              remote: true,
              remoteMethod: (query) => this.remoteMethod(field, query),
            },
            loading: this.$store.state.buttonApilsLoading,
            events: {
              change: ({ row, rowIndex }) => {
                this.changeRow(field, row, rowIndex);
              },
            },
          };
          if (field === 'scanType') {
            editRender.options = this.scanTypeList;
            editRender.optionProps = {
              label: 'dictValue',
              value: 'dictCode',
            };
          } else if (field === 'awardWay') {
            editRender.options = this.awardWayList;
            editRender.optionProps = {
              label: 'dictValue',
              value: 'dictCode',
            };
          } else if (field === 'wayType') {
            editRender.options = this.wayTypeList;
            editRender.optionProps = {
              label: 'dictValue',
              value: 'dictCode',
            };
          }
        }
      } else if (!this.disabled && type === 'DatePicker') {
        editRender = {
          name: 'ElDatePicker',
          props: {
            placeholder: `请选择${title}`,
            clearable: true,
            valueFormat: 'yyyy-MM-dd',
          },
        };
      }
      return {
        ...column,
        editRender,
      };
    },
    // 渲染回显
    resetText(row, field) {
      let text = '';
      if (this.numberList.includes(field)) {
        text = row[field] ? row[field].toFixed(2) : '';
      } else if (field === 'scanType') {
        text = row.scanTypeName || '';
      } else if (field === 'awardWay') {
        text = row.awardWayName || '';
      } else if (field === 'wayType') {
        text = row.wayTypeName || '';
      } else {
        text = row[field];
      }
      return text;
    },
    // 单元格是否允许编辑
    activeCellMethod({ column, row, rowIndex }) {
      console.log(row);
      return true;
    },
    // 远程搜索
    remoteMethod(field, query, index) {
      if (field === 'scanType' || field === 'awardWay' || field === 'wayType') {
        this.getTypeList(query);
      }
    },
    // 编辑监听
    changeRow(field, row, index) {
      const list = JSON.parse(JSON.stringify(this.value));
      console.log(list);
      let _item = null;

      switch (field) {
        case 'scanType':
          _item = this.scanTypeList.find((v) => v.dictCode === row.scanType);

          list[index] = {
            ...list[index],
            scanTypeName: _item ? _item.dictValue : '',
          };
          break;
        case 'awardWay':
          _item = this.awardWayList.find(
            (v) => v.dictCode === row.awardWay,
          );

          list[index] = {
            ...list[index],
            awardWayName: _item ? _item.dictValue : '',
          };
          break;
        case 'wayType':
          _item = this.wayTypeList.find(
            (v) => v.dictCode === row.wayType,
          );

          list[index] = {
            ...list[index],
            wayTypeName: _item ? _item.dictValue : '',
          };
          break;
        default:
          break;
      }

      this.$emit('input', list);
    },
    // 计算费用
    countFn(row) {
      const { wayMoney, distanceAstrict } = row;
      let countNum = 0;
      if (wayMoney) {
        countNum = Number(wayMoney).toFixed(2);
      } else if (distanceAstrict) {
        countNum = Number(distanceAstrict).toFixed(2);
      }
      return countNum;
    },
    // 客户类型和终端类型
    getTypeList(query) {
      const param = ['scan_type', 'award_way', 'wayType'];
      request.post('/mdm/mdmdictdata/batchDictSelect', param).then((res) => {
        if (res.success) {
          this.scanTypeList = res.result.scan_type || [];
          this.awardWayList = res.result.award_way || [];
          this.wayTypeList = res.result.wayType || [];
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.detailed-table {
  padding-left: 50px;

  .text-red {
    color: #f56c6c !important;
  }
}
</style>
